import { render } from "./AdminRejected25Liquidations.vue?vue&type=template&id=e33ba266"
import script from "./AdminRejected25Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminRejected25Liquidations.vue?vue&type=script&lang=js"

import "./AdminRejected25Liquidations.vue?vue&type=style&index=0&id=e33ba266&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__